module.exports = __webpack_public_path__ + "img/cyyc3.45057f57.jpg";